"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCookie = exports.getCookie = exports.setCookie = void 0;
/**
 * Sets a cookie with the given name, value and expiry days. Only works in browser environemnt.
 * @param cookieName the name of the cookie to set
 * @param cookieValue the value of the cookie to set
 * @param expiryDays the number of days until the cookie expires
 * @returns void
 */
const setCookie = (cookieName, cookieValue, expiryDays) => {
    const d = new Date();
    d.setTime(d.getTime() + expiryDays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
};
exports.setCookie = setCookie;
/**
 * Returns the value of the cookie with the given name. Only works in browser environemnt.
 * @param cookieName the name of the cookie to get
 * @returns the value of the cookie
 */
const getCookie = (cookieName) => {
    const name = cookieName + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};
exports.getCookie = getCookie;
/**
 * Removes the cookie with the given name. Only works in browser environemnt.
 * @param cookieName the name of the cookie to remove
 * @returns void
 */
const removeCookie = (cookieName) => {
    (0, exports.setCookie)(cookieName, '', -1);
};
exports.removeCookie = removeCookie;
//# sourceMappingURL=cookies.js.map